import dayjs from 'dayjs';
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';
import { useTableContext } from '../../contexts/TableContext';
import RoutesApp from '../../routes';

//Servicios
import { GuiasService } from '../../services/api';

//Componentes
import Spinner from '../spinner/Spinner';
import GuiaSearch from './GuiaSearch';

//Estilos
import right_arrow from '../../assets/imgs/next.png';

function GuiaSearchContainer({ searchData }) {
    const { masters, SearchParameters } = useGlobalContext();
    const { state } = useTableContext();
    const tablePage = useMemo(() => state.GuiaPage, [state.GuiaPage]);

    const [loader, setLoader] = useState(false);
    let apiTablePages;

    useEffect(() => {
        const getGuiaSearchCuantity = async () => {
            try {
                setLoader(true);

                const GuiaSearchCuantity = await GuiasService.totalRecords({
                    ...SearchParameters.guias,
                });

                if (GuiaSearchCuantity) apiTablePages = GuiaSearchCuantity.data;

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        const getGuiaSearch = async () => {
            try {
                setLoader(true);

                const GuiaSearch = await GuiasService.search({
                    ...SearchParameters.guias,
                    pagina: tablePage,
                });

                if (GuiaSearch) {
                    setTableData(
                        buildTableData(GuiaSearch.data, apiTablePages)
                    );
                }

                setLoader(false);
            } catch (err) {
                setLoader(false);
                return err;
            }
        };

        getGuiaSearchCuantity();
        getGuiaSearch();
    }, [tablePage, SearchParameters.guias]);

    const buildTableData = (data = [], tablePages) => {
        return {
            title: 'Guías ',
            headers: [
                // 'ID',
                'Guía',
                'Titulares Viñedo',
                'Matrícula Vehículo',
                // 'Destino',
                'Estado',
                'Viñedo',
                ' ',
            ],
            pagination: 10,
            tablePages,
            pageType: 'GuiaPage',
            data:
                data.length > 0
                    ? data?.map((g) => {
                          return {
                              guia: g.guia_Papel
                                  ? `${g.serie}-G-${g.numero} / ${g.guia_Papel}`
                                  : `${g.serie}-G-${g.numero}`,
                              //guia: `${g.serie}-G-${g.numero}`,
                              titularViniedo: g.titular_Viniedo,
                              matriculaVehiculo: g.matricula_Vehiculo,
                              //   destino: ,
                              estado: masters?.GuiaStateTypes.find(
                                  (gst) => gst.id === g.estado
                              )?.nombre,
                              viñedo: g.viniedo,
                              icons: (
                                  <div>
                                      <Link
                                          to={RoutesApp.Guias.single + g.id}
                                          className="table-icon_container"
                                      >
                                          <img
                                              className="table-icon"
                                              src={right_arrow}
                                              title="Visualizar"
                                              alt="Visualizar"
                                          />
                                      </Link>
                                  </div>
                              ),
                          };
                      })
                    : [],
        };
    };

    const [tableData, setTableData] = useState(buildTableData());

    return loader ? <Spinner /> : <GuiaSearch tableData={tableData} />;
}

export default GuiaSearchContainer;
